var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AuthLayout,[(_setup.loginSSO)?_c(_setup.AuthLoginSso):_c(_setup.AuthLogin)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }